/** @file Deletes an image that no attachment or reference uses (VALIDATION otherwise). */
import { throwError } from '@pose2d/format/throwError';
import { defineCommand } from '../defineCommand';
import { defineRemove } from '../_shared/defineRemove';

const remove = defineRemove({ domain: 'image', kind: 'image', description: 'Delete an unused image (fails while an attachment or reference uses it).' });

export const command = defineCommand({
  ...remove,
  apply(draft, input, ctx) {
    const users = ctx.index.referencedBy.get(ctx.resolve('image', input.target));
    if (users && users.size > 0) {
      throwError('VALIDATION', undefined, { path: 'target', hint: `image is used by ${[...users].join(', ')}; delete or retarget those first` });
    }
    remove.apply(draft, input, ctx);
  },
});
